export const date = "23.06.23";
export const time = "15.00";
export const dayWeek = "пятница";
export const year = "2023 год";
export const month = "июня";



